import { createFileRoute } from '@tanstack/react-router'

import { CourseGenericThemeWrapper } from '@/course-generic/components/CourseGenericThemeWrapper/CourseGenericThemeWrapper'

export const Route = createFileRoute(
  '/_learning/discover/course-generic/$courseSlug/$themeSlug',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <CourseGenericThemeWrapper />
}
